// Mimic bootstrap collapse
// https://medium.com/dailyjs/mimicking-bootstraps-collapse-with-vanilla-javascript-b3bb389040e7
// map our commands to the classList methods
/** @type {{[key: string]: Extract<keyof DOMTokenList, 'toggle' | 'add' | 'remove'>}} */
const fnmap: { [key: string]: Extract<keyof DOMTokenList, 'toggle' | 'add' | 'remove'> } = {
  toggle: 'toggle',
  show: 'add',
  hide: 'remove',
}

const collapse = (selector: string, cmd: keyof typeof fnmap) => {
  const targets: NodeListOf<HTMLElement> = document.querySelectorAll(selector)
  targets.forEach((target) => {
    target.classList[fnmap[cmd]]('show')
  })
}

export const initializeCollapse = () => {
  const triggers = Array.from(document.querySelectorAll('[data-toggle="collapse"]')) // Listen for click events, but only on our triggers

  window.addEventListener(
    'click',
    (ev) => {
      const elm = ev.target as HTMLElement | null
      if (!elm) return
      if (triggers.includes(elm)) {
        const selector = elm.getAttribute('data-target')
        if (!selector) return
        collapse(selector, 'toggle')
      }
    },
    false
  )
}
